import { PRODUCT_TEMPLATES } from '../productTemplates'

export const productAccessorIsRxOrOtxTemplate = (
  productTemplate: PRODUCT_TEMPLATES,
): boolean =>
  new Set<PRODUCT_TEMPLATES>([PRODUCT_TEMPLATES.OTX, PRODUCT_TEMPLATES.RX]).has(
    productTemplate,
  )
